import * as z from "zod";

export const trackingTextFields = ["message", "location"] as const;
export type TrackingTextField = (typeof trackingTextFields)[number];

export const trackingTextTargets = [...trackingTextFields, "all"] as const;
export type TrackingTextTarget = (typeof trackingTextTargets)[number];
export const TrackingTextTarget = trackingTextTargets;

export const trackingTextPhrasesSchema = z
  .array(z.string().trim().min(1))
  .min(1);

const trackingTextRuleSchema_ = z.object({
  target: z.enum(trackingTextTargets),
  phrases: trackingTextPhrasesSchema,
  replacement: z.string(),
});

export const trackingTextRuleSchema: z.ZodType<TrackingTextRule> =
  trackingTextRuleSchema_;

export interface TrackingTextRule extends z.infer<
  typeof trackingTextRuleSchema_
> {}
